import {districtList} from './app.constant'

export const HOME = '/'
export const DETAILS = '/[slug]'
export const ROOT = '/[url]'
export const BLOG_LIST = '/blog-dau-tu'
export const BLOG_DETAILS = '/blog-dau-tu/[slug]'
export const CATEGORY = '/danh-muc/[slug]'
export const SALE_PAGE = '/mua-ban'
export const SALE_BY_DISTRICT = '/ban-nha-[slug]'
export const RENT_PAGE = '/thue-nha'
export const RENT_BY_DISTRICT = '/thue-nha-[slug]'
export const SEARCH = '/search'
export const CONSIGNMENT = '/ky-gui'
export const NOT_FOUND = '/404'

export const SALE_PAGE_URLS = [
  ...districtList.map((district) => `ban-nha-${district.slug}`),
  'mua-ban',
  'ban-nha-cac-quan-khac',
]

export const RENT_PAGE_URLS = [
  ...districtList.map((district) => `thue-nha-${district.slug}`),
  'thue-nha',
  'thue-nha-cac-quan-khac',
]
